<div class=" p-2 min-w-[80%]">
	<div class="flex items-center gap-2 mb-5">
		<img ngSrc="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/logo-brown.svg" width="40" height="40" alt="Anuprerna">
		<h1 class="text-2xl uppercase text-[#8E7862]">Anuprerna</h1>
	</div>
	<div class="fb-login-form-container flex flex-col items-stretch">
		<h3 class="font-medium text-2xl mb-2">Welcome</h3>
		<p class="text-[#9fa6b8]">Use your email or another service to continue </p>
		<div class="fb-auth-provider my-3">
			<div class="flex flex-col justify-between gap-2">
				<button (click)="getAuthProvider(AuthProviderEnum.BASIC)"
						class="w-full mt-2 rounded border-2 border-[#8E7862] text-[#8E7862] py-2 hover:border-[#6c5b48]
						transition-colors flex items-center justify-center gap-2 text-sm sm:text-base"
						type="submit">
					<span class="material-symbols-outlined">
						email
					</span>
				Continue with Email
			</button>
				<button (click)="getAuthProvider(AuthProviderEnum.GOOGLE)"
						class="w-full mt-2 rounded border-2 border-[#8E7862] text-[#8E7862] py-2 hover:border-[#6c5b48]
						transition-colors flex items-center justify-center gap-2 text-sm sm:text-base"
						type="submit">
					<img ngSrc="assets/img/google_logo.svg" width="20" height="20" alt="Google">
					Continue with Google
				</button>
<!--				<button (click)="getAuthProvider(AuthProviderEnum.FACEBOOK)"-->
<!--						class="w-full mt-2 rounded border-2 border-[#8E7862] text-[#8E7862] py-2 hover:border-[#6c5b48]-->
<!--						transition-colors flex items-center justify-center gap-2 text-sm sm:text-base"-->
<!--						type="submit">-->
<!--					<img ngSrc="assets/img/fb_blue.svg" width="20" height="20" alt="Facebook">-->
<!--					Continue with Facebook-->
<!--				</button>-->

			</div>
			<div class="w-full flex flex-col justify-start text-sm my-3">
				<p class="text-[#9fa6b8]">By continuing you agree to the website's
					<a class=" text-[#8E7862] underline"
					   href="https://anuprerna.com/content/policies/terms-conditions/174271"
					   target="_blank">T&C</a> &
					<a class=" text-[#8E7862] underline"
					   href="https://anuprerna.com/content/policies/privacy-policy/173823"
					   target="_blank"> Privacy Policies</a></p>
				<p class="text-[#9fa6b8]">and to receive emails for service related information.</p>
			</div>
		</div>
	</div>
</div>
